import { getAllTableData } from "@api/admin.js";
export default {
  props: {
    paasTreeParentName:String,
  },
  data(){
    return {
      serviceUrl:'', //后台访问路径，必须
      queryParam:{
        query_EQ_parentId:'',
        queryOrderBy_: 'displayOrder@asc',
      },
      currentIdFiledName:'',//必须
      //queryProps:"", //页面查询字段，必须
      tableData:[],  //表单数据
      totalRecords:0, //分页数据总数
      tableSelectedDatas: [], //表格已选项
      paasCurrentFunctionId:'', //功能id
      defaultModalTitle:'系统提示', //删除模态框title
      defaultDeleteModalContent:'确定要删除吗？', //删除模态框content
      noDataText:'<img src="/image/no-data-img.png"/>', //table没数据的时候显示的图片
      tableHeight:(document.documentElement.clientHeight -210), //table默认高度
      defaultLabelWidth:100, //默认表单域标签的宽度,所有的 FormItem 都会继承 Form 组件的 label-width 的值
    }
  },
  created() {
    this.created();
  },
  methods: {
    created() {
      this.paasCurrentFunctionId= this.$route.query.paasCurrentFunctionId;
      let parentId = this.$route.query[this.currentIdFiledName];
      if(!parentId || typeof (parentId) === "undefined"){
        parentId = "root";
      }
      this.queryParam.query_EQ_parentId = parentId;
      this.queryTableBeforeLogic();
      this.queryTableDatas();
    },
    /**
     * 查询之前组织查询参数
     */
    queryTableBeforeLogic(){

    },
    createdCallback() {

    },

    /**
     * 查询列表数据
     */
    queryTableDatas(type,nodeId){
      getAllTableData(this.serviceUrl,this.queryParam).then(res => {
        if(res.code === 200){
          this.tableData = res.data;
          //树节点删除某一节点需要刷新左侧树，刷新树的同时需要展开该节点
          if(type === "delete"){
            this.$bus.emit("update-delete-tree",nodeId);
          }
        }
      })
    },
    /**
     * @on-selection-change，只要选中项发生变化时就会触发，返回值为 selection，已选项。
     */
    selectTableDataChange(selecttion){
      this.tableSelectedDatas = selecttion;
    },
    /**
     * @on-sort-change table排序时有效，当点击排序时触发 tableColumns里边有sortable: true，才有效
     * @param sort (column,key,order) order有三种状态：asc、desc、normal（恢复到开始状态）
     */
    sortTableData(sort) {
      //恢复到初始状态
      if(sort.order === "normal") {
        this.queryParam.queryOrderBy_ = this.queryParam.initOrderParam;
      }
      //asc、desc
      else {
        this.queryParam.queryOrderBy_ = sort.key+"@"+sort.order;
      }
      this.queryTableDatas();
    },
    /**
     * 增、删、改、查
     * */
    /**
     * 添加按钮
     * */
    paasAddPage(event, url) {
      if(!url) {
        url = this.serviceUrl+'/edit';
      }
      this.$router.push({'path':this.setUrlFuncId(url)});
    },
    /**
     * 添加根节点
     */
    paasAddRoot(event, url) {
      if(!url) {
        url = this.serviceUrl+"/edit?parentId=root";
      }
      this.updateTimeKey();
      this.$router.push({'path':this.setUrlFuncId(url)});
    },
    /**
     * 添加子节点
     */
    paasAddChildNode(event,url){
      if(!url) {
        url = this.serviceUrl+"/edit?parentId="+ this.queryParam.query_EQ_parentId;
      }
      this.$router.push({'path':this.setUrlFuncId(url)});
    },
    /**
     * toolbar修改按钮
     * */
    paasEidtPage() {
      let selectedDatas = this.tableSelectedDatas;
      if(selectedDatas.length !== 1) {
        this.$Message.warning('请选择要修改的数据！');
      }
      else if(selectedDatas.length > 1){
        this.$Message.warning('请选择一行进行修改！');
      }
      else {
        this.paasEditOper(selectedDatas[0][this.currentIdFiledName]);
      }
    },
    /**
     * 修改，参数是主键id对应的值，也适用于表单内修改操作
     * */
    paasEditOper(data, url) {
      if(!url) {
        url = this.serviceUrl+'/edit';
      }
      if(url.indexOf("?") !== -1) {
        url += '&'+this.currentIdFiledName+"="+data;
      } else {
        url += "?"+this.currentIdFiledName+"="+data;
      }
      this.$router.push({'path': this.setUrlFuncId(url)});
    },
    /**
     * 删除模态框
     */
    paasDeleteConfirmModel(title,content,id){
      let modalTitle = this.defaultModalTitle;
      let modalContent = this.defaultDeleteModalContent;
      if(title){
        modalTitle = title;
      }
      if(content){
        modalContent = content;
      }
      this.$Modal.confirm({
        title: modalTitle,
        content: modalContent,
        onOk: () => {
          this.paasConfirmDelete(id);
        },
        onCancel: () => {
          this.$Message.info('取消模态框');
        }
      });
    },
    /**
     * toolbar 删除按钮
     * */
    paasDeleteTableData() {
      let selectedDatas = this.tableSelectedDatas;
      if(selectedDatas.length === 0) {
        this.$Message.info('请选择要删除的数据！');
      }
      else {
        this.paasDeleteConfirmModel("","");
      }
    },
    /**
     * 表单内删除操作
     */
    paasDeleteOper(data){
      this.paasDeleteConfirmModel("","",data);
    },
    /**
     * 点击模态框的确定删除
     * */
    paasConfirmDelete(id){
      //表头删除
      let ids = "";
      if(!id){
        let selectedDatas = this.tableSelectedDatas;
        for(let i = 0; i < selectedDatas.length; i++) {
          if(ids) {
            ids += ",";
          }
          ids += selectedDatas[i][this.currentIdFiledName];
        }
      }else{
        ids = id;
      }
      this.axios.post(this.$store.state.sysApi+this.serviceUrl+"/delete?"+this.currentIdFiledName+"s="+ids).then(res=> {
        this.$Modal.remove();
        this.$Message.info('数据删除成功！');
        this.queryTableDatas("delete"); //删除后刷新数据
      }).catch(error=>{
        this.$Modal.remove();
        this.$Message.info('数据删除失败，请重试！');
        console.log("list的数据："+error);
      });
    },
    /**
     * 删除树节点
     * @param param
     */
    deleteTreeNode(param){
      this.$Modal.confirm({
        title: '系统提示',
        content: '删除操作将会把本节点及其所有下级节点全部删除，确定要删除吗？',
        onOk: () => {
          this.paasDeleteNode(param.row[this.currentIdFiledName]);
        },
        onCancel: () => {
          this.$Modal.remove()
        }
      })
    },
    paasDeleteNode(nodeId){

      this.axios.post(this.$store.state.sysApi+this.serviceUrl+"/delete?ids="+nodeId)
        .then(res=> {
          this.$Modal.remove();
          this.$Message.info('数据删除成功！');
          this.queryTableDatas("delete",nodeId); //删除后刷新数据
        }).catch(error=>{
        this.$Modal.remove();
        this.$Message.info('数据删除失败，请重试！');
      });
    },
    /**
     * 查看
     * */
    paasDetailPage() {
      let selectedDatas = this.tableSelectedDatas;
      if(selectedDatas.length !== 1) {
        this.$Message.warning('请选择要查看的数据！');
      }
      else if(selectedDatas.length > 1){
        this.$Message.warning('请选择一行进行查看！');
      }
      else {
        this.paasDetailOper(selectedDatas[0][this.currentIdFiledName]);
      }
    },
    /**
     * 查看，参数是主键id对应的值
     * */
    paasDetailOper(data, url) {
      if(!url) {
        url = this.serviceUrl+'/detail';
      }
      if(url.indexOf("?") !== -1) {
        url += '&'+this.currentIdFiledName+"="+data;
      } else {
        url += "?"+this.currentIdFiledName+"="+data;
      }
      this.$router.push({'path': this.setUrlFuncId(url)});
    },
    /**
     * 把index1的节点拖动到index2位置
     * */
    dropNode(fromIndex,toIndex){
      /**
       * 获取一个新的数组，更新数组编码
       */
      let dragNewData = [];
      //filter 过滤掉第index1的数据
      dragNewData = this.tableData.filter(data => {
        return data[this.currentIdFiledName] !== this.tableData[fromIndex][this.currentIdFiledName];
      })
      //把index1数据放到index2位置
      dragNewData.splice(toIndex,0,this.tableData[fromIndex]);
      this.paasTreeOrderSave(dragNewData,fromIndex,toIndex);
    },
    /**
     * update排序后的数组数据
     * @param data
     * @param fromIndex
     * @param toIndex
     * */
    paasTreeOrderSave(data,fromIndex,toIndex) {
      let ids = "";
      for(let i = 0; i < data.length; i++) {
        if(ids) {
          ids += ",";
        }
        ids += data[i][this.currentIdFiledName];
      }
      this.axios.post(this.$store.state.sysApi+this.serviceUrl+"/saveTreeOrderData?ids="+ids)
        .then(res=> {
          if(res.code === 200) {
            //更新table排序
            this.tableData = data;
            //更新树
            let parentId = this.$route.query[this.currentIdFiledName];
            //说明移动的是根节点
            if(typeof(parentId) == "undefined"){
              parentId = "root";
            }
            this.$bus.emit("update-order-tree",parentId,fromIndex,toIndex);
          }
        }).catch(error=> {
        this.$Message.error('排序数据保存失败，请重试！');
      });
    },

    /**
     * 页码改变的回调，返回改变后的页码
     * @param currentPage
     */
    changePage (currentPage) {
      this.queryParam.iDisplayStart = (currentPage - 1) * this.queryParam.iDisplayLength;
      this.queryParam.currentPageNum = currentPage;
      this.queryTableDatas();
    },
    /**
     * 改变每页显示数量
     * @param pageSize
     */
    changePageSize (pageSize) {
      this.queryParam.iDisplayLength = pageSize;
      this.queryTableDatas();
    },
    /**
     * url添加功能ID参数,封装这个方法是以防功能配置也有传参数
     * */
    setUrlFuncId(url) {
      if(url.indexOf("?") !== -1) {
        url += '&';
      } else {
        url += '?';
      }
      //组装paasCurrentFunctionId=***
      url += this.$store.state.funcIdName+'='+this.$route.query[this.$store.state.funcIdName];
      return url;
    },
    /**
     * 数字控件NumSelect存在时
     */
    queryData(data){
      this.queryParam['query_LT_'+data.name] = data.upper;
      this.queryParam['query_GTE_'+data.name] = data.sub;
      this.queryTableDatas();
    },
    /**
     * 计算table的高度
     * @param flag
     */
    calculateTableHeight(flag){
      let docHeight = document.documentElement.clientHeight; //可见区域的高度
      /**
       * 只能是元组件才有的方法
       * 距离父组件的高度
       * @type {number}
       */
      let queryOffsetTop = this.$refs.listWrap.getBoundingClientRect().top;
      let queryHeight = 0;
      if(flag || typeof(flag) === 'undefined'){
        /**
         * 当前组件的高度，非元组件
         * @type {number}
         */
        if(typeof(this.$refs.queryForm) !== "undefined"){
          queryHeight = this.$refs.queryForm.$el.clientHeight;
        }
      }

      this.tableHeight = docHeight - queryOffsetTop - queryHeight - 48;
    },
    /**
     * 切换收缩按钮计算table的高度
     * @param flag
     */
    paasCalculate(flag){
      this.$nextTick(() => {
        this.calculateTableHeight(flag);
      })
    },
    mountedCallback(){
      this.watchUpdateList();
    },
    watchUpdateList(){
      this.$bus.on("update-list",(id)=>{
        this.queryTableDatas("delete",id);
      })
    }
  },
  mounted(){
    this.$nextTick(() => {
      this.calculateTableHeight();
      this.mountedCallback();
    });

  },
  watch:{
    $route(to,from){
      /**
       * 如果有配置keepAlive属性的说明需要缓存,而且只有这些路由到当前list路由需要缓存list的配置
       */
      if(this.keepAliveName){
        if(this.keepAliveName.indexOf(from.name) !== -1){
          to.meta.keepAlive = true;
        }else{
          to.meta.keepAlive = false;
        }

        if(this.keepAliveName.indexOf(to.name) !== -1){
          from.meta.keepAlive = true;
        }else{
          from.meta.keepAlive = false;
        }
      }
    }
  },
}
